<template>
  <div>
    <img class="icon" :src=loadImg>
    {{text}}
  </div>
</template>

<script>

export default {
  name: 'image-horizontal',
  props: {
    img: { type: String },
    text: { type: String }
  },
  computed: {
    loadImg () {
      return require(`@/assets/${this.img}`)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import './../../unified.scss';
.icon {
  width:1rem;
}

</style>



// WEBPACK FOOTER //
// src/components/Molecules/ImageHorizontal.vue